<template>
    <transition name="fade" tag="v-layout" class="row wrap">
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <transition name="fade" mode="out-in">
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="accent white--text title">
                    Pumps Runtime
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs3>
                                <vue-plotly v-if="pumpOnData" disable-responsive :data="pumpOnData" :layout="pumpOnLayout" :options="{}"/>
                            </v-flex>
                            <v-flex v-for="plot in plotList" :key="'ms2'+plot.id"  xs9 >
                                <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                                  :date-range="plot.config['range'] ? plot.config['range'] : refinedRange"
                                                  :variable-x="plot.config['variable-x']"
                                                  :variables-list="plot.config['variables-list']"
                                                  :layout-overrides="plot.config['layout-overrides']"
                                                  :type="plot.config['type']"
                                                  just-plot
                                ></multi-plot-chart>
                                <data2-chart ref="plots" v-if="plot.type==='data2-chart'"
                                             :layout-overrides="plot.config['layout-overrides']"
                                             :x-axis="plot.config['x-axis']"
                                             :data-payload="plot.config['data-payload']"
                                             :series-overrides="plot.config['series-overrides']"
                                             just-plot :date-range="plot.config['range'] ? plot.config['range'] : refinedRange"></data2-chart>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
        </transition>
    </transition>
</template>

<script>

    import moment from 'moment'
    import {callAPI,getNotification} from '@/helper'
    import VuePlotly from "../components/VuePlotly";
    import MultiPlotChart from "../components/MultiPlotChart";
    import Data2Chart from "../components/Data2Chart";
    import DateRangeSelector from "../components/DateRangeSelector";


    export default {
        name: 'AAPumpRuntime',
        components: {VuePlotly,MultiPlotChart,Data2Chart,DateRangeSelector},
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.facility_name
            },
            plotList() {
                return [
                    {
                        'id': 53432,
                        'type': 'data2-chart',
                        'config': {
                            'layout-overrides': {
                                title:'Pumps on',
                                xaxis: {
                                    title: "Date "
                                },
                                legend: {
                                    orientation: 'h',
                                    y:-0.2
                                },
                                margin:{
                                    l: 50,
                                    r: 50,
                                    t: 30,
                                    pad: 1
                                },
                            },
                            'data-payload': {
                                'filters': {
                                    'sensor_names': ["on"],
                                    "equipment_type": "SCP",
                                }
                            },
                            'series-overrides':{
                                stackgroup: 'one',
                                mode: 'none',
                            },
                        }
                    }
                ]
            }
        },
        data () {
            return {
                menu:false,
                baseDate:  moment().subtract(31, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(31, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                refinedRange:  null,
                loading:true,
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                chillers:[],
                pumps:[],
                ahus:[],
                headers: [
                    {
                        text: 'Issue',
                        align: 'left',
                        sortable: true,
                        value: 'title'
                    },
                    {text: 'Equipment', value: 'equipment_name'},
                    {text: 'Equipment Type', value: 'equipment_type'},
                    {text: 'Floor', value: 'floor'},
                    {text: 'Start Date', value: 'start_date'},
                    {text: 'End Date', value: 'end_date'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                faults:[],
                faultPieData1:null,
                faultPieData2:null,
                faultPieLayout1:{
                    title:"Fault severity",
                    legend: {
                        orientation: 'h',
                        x: 0.1
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                faultPieLayout2:{
                    title:"Fault breakdown",
                    legend: {
                        orientation: 'h',
                        x:0.1
                    },
                    margin:{
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },
                roomTempData:null,
                roomTempLayout:{
                    title:"Room Temperature (°C)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    yaxis: {
                        range:[0,35]
                    },
                    margin:{
                        l: 30,
                        r: 20,
                        b: 20,
                        t: 100,
                        pad: 1
                    },
                },
                ahuOnData:null,
                pumpOnData:null,
                ahuOnLayout:{
                    title:"AHU Run Time (hr)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 30,
                        r: 20,
                        b: 20,
                        t: 100,
                        pad: 1
                    },
                },pumpOnLayout:{
                    title:"Pump Run Time (hr)",
                    showlegend:false,
                    hovermode: 'closest',
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 30,
                        r: 20,
                        b: 20,
                        t: 100,
                        pad: 1
                    },
                },
                chillerOnData:null,
                chilerOnLayout:{
                    title:"Chiller Run Time (hr)",
                    hovermode: 'closest',
                    showlegend:false,
                    xaxis: {
                        showgrid:false,
                        ticks:'',
                        showticklabels:false
                    },
                    margin:{
                        l: 20,
                        r: 20,
                        b: 20,
                        t: 50,
                        pad: 1
                    },
                },


            }
        },

        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    if(!ar2[i]){
                        ar3.push(ar1[i]);
                    } else {
                        ar3.push(ar1[i] + ar2[i]);
                    }
                return ar3;
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            getData(){
                let me=this;
                me.loading=true
                me.chillers=[]
                me.pumps=[]
                me.ahus=[]
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                me.refinedRange={
                    start:currentRange[0],
                    end:currentRange[1],
                }
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        me.chillers.push(equip.equipment_name)
                    } else if(equip.equipment_type.toLowerCase().startsWith('ahu')){
                        me.ahus.push(equip.equipment_name)
                    } else if (equip.equipment_type==="SCP"){
                        me.pumps.push(equip.equipment_name)
                    }
                }
                me.ahus.sort()
                if(me.pumps.length>0) {
                    callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                                'equipment_type': 'SCP',
                                'sensor_names': ['on'],
                                'date_range': currentRange,
                            }
                        }
                    ).then(function (pumpRes) {
                        let increm = 1 / me.$store.state.pointsListStore.pointsList.sampling_freq
                        let pumpNames = []
                        let pumpOn = []
                        for (let pump of me.pumps) {
                            if (pumpRes.data[pump + ' - on']) {
                                pumpNames.push(pump)
                                let ontime = 0
                                for (let flowindex in pumpRes.data[pump + ' - on']) {
                                    let flow = pumpRes.data[pump + ' - on'][flowindex]
                                    if (flow > 0) {
                                        ontime = ontime + increm

                                    }
                                }
                                pumpOn.push(ontime)
                            }
                        }
                        me.pumpOnData = [{
                            x: pumpNames,
                            y: pumpOn,
                            type: 'scatter',
                            mode: 'markers',
                            marker: {
                                symbol: 'circle',
                                size: 10
                            }
                        }]
                        me.loading=false

                    })
                }



            }

        },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.baseDate=moment(maxDate).subtract(31, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }



    }
</script>
